import Vue from 'vue'
import VueBarcode from '@chenfengyuan/vue-barcode'

Vue.component(VueBarcode.name, VueBarcode)
